import {CLEAN_DRIVER_LIST, GET_DRIVER, CREATE_DRIVER, GET_DRIVERS_WALLET, ADD_DRIVERS_WALLET_TRANSACTION, GET_DRIVERS_WALLET_TRANSACTION, ADD_DRIVERS_WALLET_BULK_TRANSACTION} from './constants';
// Const
import {
  GET_DRIVERS,
  UPDATE_DRIVER,
  GET_VEHICLE_PREFERRED_SOURCES,
  GET_CENTERS,
  UPDATE_VEHICLE_PREFERRED_SOURCES,
  GET_DRIVER_SHIFTS,
  UPDATE_DRIVER_SHIFTS,
  UPDATE_DRIVER_STATUS,
} from './constants';

// Type
import {Payload, Driver, DriverShift} from './interfaces';

export function getDriversAction(payload: Payload) {
  return {
    type: GET_DRIVERS,
    payload,
  };
}

export function getDriverAction(payload: Payload) {
  return {
    type: GET_DRIVER,
    payload,
  };
}

export function getDriverWalletTransactionAction(payload: Payload) {
  return {
    type: GET_DRIVERS_WALLET_TRANSACTION,
    payload,
  };
}

export function getDriversWalletAction(payload: Payload) {
  return {
    type: GET_DRIVERS_WALLET,
    payload,
  };
}

export function addWalletDriversTransactionAction(payload: Payload) {
  return {
    type: ADD_DRIVERS_WALLET_TRANSACTION,
    payload,
  };
}

export function addWalletDriversBulkTransactionAction(payload: Payload) {
  return {
    type: ADD_DRIVERS_WALLET_BULK_TRANSACTION,
    payload,
  };
}

export function createDriverAction(payload: Payload) {
  return {
    type: CREATE_DRIVER,
    payload,
  };
}

export function updateDriverActions(payload: Payload) {
  return {
    type: UPDATE_DRIVER,
    payload,
  };
}

export function updateDriverStatusActions(payload: Payload) {
  return {
    type: UPDATE_DRIVER_STATUS,
    payload,
  };
}

export function getVehiclePreferredSourcesAction(id: number) {
  return {
    type: GET_VEHICLE_PREFERRED_SOURCES,
    payload: id,
  };
}

export function updateVehiclePreferredSourcesAction(payload: {
  id: number;
  body: number[];
}) {
  return {
    type: UPDATE_VEHICLE_PREFERRED_SOURCES,
    payload,
  };
}

export function getAllCentersAction() {
  return {
    type: GET_CENTERS,
  };
}

export function cleanDriverListAction() {
  return {
    type: CLEAN_DRIVER_LIST
  }
}

export function getDriverShiftsAction(payload: {id: number}) {
  return {
    type: GET_DRIVER_SHIFTS,
    payload,
  };
}

export function updateDriverShiftsAction(payload: {
  body: DriverShift;
  id: number;
  callback: () => void;
}) {
  return {
    type: UPDATE_DRIVER_SHIFTS,
    payload,
  };
}
